export const FEATURE_NAME = '@zerops/zerops/feature/menu-panel';
